
import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Title,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import annotationPlugin from "chartjs-plugin-annotation";
import AverageMachineSellFilter from "../filters/AverageMachineSellFilter";
import fetchHook from "../../../../../hooks/fetchMSSQL-hook";
import getGradientForBarValue from "../../utils/getGradientForBarValue";
import getMachinesSalesAverageChartConfig from "../../configs/getMachinesSalesAverageChartConfig";
import getMachinesSalesSumChartConfig from "../../configs/getMachinesSalesSumChartConfig";

ChartJS.register(
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Title,
  Legend,
  annotationPlugin
);

export default function MachinesSalesCharts({showMachinesStat, setShowMachinesStat}) {
  const chartRef = useRef(null);
  const chartRef2 = useRef(null);
  const { fetchMssqlApi } = fetchHook();
  const [avarageMachinesSale, setAvarageMachinesSale] = useState([]);
  const [machinesSale30d, setMachinesSale30d] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [machineFilter, setMachineFilter] = useState("");
  const [paymentType, setPaymentType] = useState(null);
  const [machineRank, setMachineRank] = useState("all");
  const [sortType, setSortType] = useState(1);
  const [showAVG, setShowAVG] = useState(false);
  const [showMedian, setShowMedian] = useState(true);
  const [timeRange, setTimeRange] = useState("30d");

  const getRangeDates = () => {
    const now = new Date();

    const to = new Date();
    to.setHours(0, 0, 0, 0);
    to.setDate(to.getDate() + 1);

    const from = new Date(to);

    switch (timeRange) {
      case "24h":
        from.setDate(to.getDate() - 1);
        break;
      case "72h":
        from.setDate(to.getDate() - 3);
        break;
      case "7d":
        from.setDate(to.getDate() - 7);
        break;
      case "30d":
        from.setDate(to.getDate() - 30);
        break;
      default:
        from.setDate(to.getDate() - 30);
    }

    return {
      FromDate: from.toISOString().slice(0, 10),
      ToDate: to.toISOString().slice(0, 10),
    };
  };

  const getSortFunction = (type) => {
    switch (+type) {
      case 1: return sortBySummaryDESC;
      case 2: return sortByAvarageDESC;
      case 3: return sortByMachineNameDESC;
      case 4: return sortBySummaryASC;
      case 5: return sortByAvarageASC;
      case 6: return sortByMachineNameASC;
      default: return sortBySummaryDESC;
    }
  };

  const getAvarageMachinesSales = async () => {
    const { FromDate, ToDate } = getRangeDates();

  const ranges = {
    "24h": 1,
    "72h": 3,
    "7d": 7,
    "30d": 30,
  };

  fetchMssqlApi(
    "/stat/avarage-machines-sales",
      {
        method: "POST",
        hideNotification: true,
        data: { 
          PaymentType: paymentType,
          FromDate,
          ToDate,
          DaysRange: ranges[timeRange]
        },
      },
    (res) => {
  const sortFn = getSortFunction(sortType);
  setAvarageMachinesSale([...res].sort(sortFn));
      },
      (err) => console.log(err)
    );
  };

  const getMachinesSales30d = async () => {
    const now = new Date();
    const from = new Date();
    from.setDate(now.getDate() - 30);

    fetchMssqlApi(
      "/stat/avarage-machines-sales",
      {
        method: "POST",
        hideNotification: true,
        data: {
          PaymentType: paymentType,
          FromDate: from.toISOString().slice(0,19).replace("T", " "),
          ToDate: now.toISOString().slice(0,19).replace("T", " ")
        }
      },
      (res) => {
      const sortFn = getSortFunction(sortType);
      setMachinesSale30d([...res].sort(sortFn));

  },

      (err) => console.log(err)
    );
  };

  const parseLocalStorage = () => {
    try {
      const values = localStorage.getItem("statFilters");
      if (!values) return false;
      
      const parsedValue = JSON.parse(values);
      return parsedValue.showMachinesStat === false ? false : Boolean(parsedValue.showMachinesStat);
    } catch (e) {
      console.log("Error parsing localStorage:", e);
      return true; 
    }
  };

  const setLocalStorage = (value) => {
    try {
      const values = localStorage.getItem("statFilters");
      let parsedValue = {};
      
      if (values) {
        parsedValue = JSON.parse(values);
      }
      
      const updatedValue = { ...parsedValue, showMachinesStat: value };
      localStorage.setItem("statFilters", JSON.stringify(updatedValue));
    } catch (e) {
      console.log("Error updating localStorage:", e);
    }
  };

  // const rankedData = applyRankFilter(avarageMachinesSale);
  
  // const filteredData = rankedData
  //   ? rankedData.filter(
  //       (machine) =>
  //         machine.MachineFullName &&
  //         machine.MachineFullName.toLowerCase().includes(
  //           machineFilter.toLowerCase()
  //         )
  //     )
  //   : [];

    const filteredData = avarageMachinesSale

const calculateMedianOfAverages = () => {
  if (!filteredData || filteredData.length === 0) return 0;
  
  const sortedValues = [...filteredData]
    .map(machine => parseFloat(machine.AverageIncomeValue || 0))
    .sort((a, b) => a - b);
  
  const midIndex = Math.floor(sortedValues.length / 2);

  if (sortedValues.length % 2 !== 0) {
    return sortedValues[midIndex];
  } else {
    return (sortedValues[midIndex - 1] + sortedValues[midIndex]) / 2;
  }
};

const calculateMedianOfSum = () => {
  if (!filteredData || filteredData.length === 0) return 0;
  
  const sortedValues = [...filteredData]
    .map(machine => parseFloat(machine.SummaryIncomeValue || 0))
    .sort((a, b) => a - b);
  
  const midIndex = Math.floor(sortedValues.length / 2);
  
  if (sortedValues.length % 2 !== 0) {
    return sortedValues[midIndex];
  } else {
    return (sortedValues[midIndex - 1] + sortedValues[midIndex]) / 2;
  }
};

const medianOfAverages = calculateMedianOfAverages();
const medianOfSum = calculateMedianOfSum();

  const sortBySummaryASC = (a, b) =>
    +a.SummaryIncomeValue > +b.SummaryIncomeValue ? 1 : -1;
  const sortByAvarageASC = (a, b) =>
    +a.AverageIncomeValue > +b.AverageIncomeValue ? 1 : -1;
  const sortByMachineNameASC = (a, b) =>
    a.MachineFullName > b.MachineFullName ? 1 : -1;
  const sortBySummaryDESC = (a, b) =>
    +a.SummaryIncomeValue < +b.SummaryIncomeValue ? 1 : -1;
  const sortByAvarageDESC = (a, b) =>
    +a.AverageIncomeValue < +b.AverageIncomeValue ? 1 : -1;
  const sortByMachineNameDESC = (a, b) =>
    a.MachineFullName < b.MachineFullName ? 1 : -1;

  const sortData = (caseType) => {
    switch (+caseType) {
      case 1:
        return setAvarageMachinesSale((prev) =>
          [...prev].sort(sortBySummaryDESC)
        );
      case 2:
        return setAvarageMachinesSale((prev) =>
          [...prev].sort(sortByAvarageDESC)
        );
      case 3:
        return setAvarageMachinesSale((prev) =>
          [...prev].sort(sortByMachineNameDESC)
        );
      case 4:
        return setAvarageMachinesSale((prev) =>
          [...prev].sort(sortBySummaryASC)
        );
      case 5:
        return setAvarageMachinesSale((prev) =>
          [...prev].sort(sortByAvarageASC)
        );
      case 6:
        return setAvarageMachinesSale((prev) =>
          [...prev].sort(sortByMachineNameASC)
        );
      default:
        return setAvarageMachinesSale((prev) =>
          [...prev].sort(sortBySummaryDESC)
        );
    }
  };

  const sortData30d = (caseType) => {
  switch (+caseType) {
    case 1:
      return setMachinesSale30d((prev) =>
        [...prev].sort((a, b) =>
          +a.SummaryIncomeValue < +b.SummaryIncomeValue ? 1 : -1
        )
      );
    case 2:
      return setMachinesSale30d((prev) =>
        [...prev].sort((a, b) =>
          +a.AverageIncomeValue < +b.AverageIncomeValue ? 1 : -1
        )
      );
    case 3:
      return setMachinesSale30d((prev) =>
        [...prev].sort((a, b) =>
          a.MachineFullName < b.MachineFullName ? 1 : -1
        )
      );
    case 4:
      return setMachinesSale30d((prev) =>
        [...prev].sort((a, b) =>
          +a.SummaryIncomeValue > +b.SummaryIncomeValue ? 1 : -1
        )
      );
    case 5:
      return setMachinesSale30d((prev) =>
        [...prev].sort((a, b) =>
          +a.AverageIncomeValue > +b.AverageIncomeValue ? 1 : -1
        )
      );
    case 6:
      return setMachinesSale30d((prev) =>
        [...prev].sort((a, b) =>
          a.MachineFullName > b.MachineFullName ? 1 : -1
        )
      );
    }
  };


  useEffect(() => {
    sortData(sortType);
    sortData30d(sortType);
  }, [sortType]);


  const totalPages = filteredData
    ? Math.ceil(filteredData.length / itemsPerPage)
    : 0;

  // const getCurrentPageData = () => {
  //   if (!filteredData || filteredData.length === 0) return [];

  //   const startIndex = (currentPage - 1) * itemsPerPage;
  //   const endIndex = startIndex + itemsPerPage;
  //   return filteredData.slice(startIndex, endIndex);
  // };

  // const currentData = getCurrentPageData();
  const applyRankFilter = (data) => {
    if (!data || data.length === 0) return [];
    // const sortedData = sortData(sortType)
    switch (machineRank) {
      case "best":
        return data.slice(0, 50);
      case "worst":
        return data.slice(Math.max(0, data.length - 50)); 
      case "all":
      default:
        return data; 
    }
  };
  const currentData = useMemo(() => {
  let data = [...avarageMachinesSale];

  if (machineRank === "best") data = data.slice(0, 50);
  else if (machineRank === "worst") data = data.slice(Math.max(0, data.length - 50));

  if (machineFilter) {
    data = data.filter(machine =>
      machine.MachineFullName?.toLowerCase().includes(machineFilter.toLowerCase())
    );
  }

    return data;
  }, [avarageMachinesSale, machineRank, machineFilter]);



  // useEffect(() => {
  //   const savedVisibility = parseLocalStorage();
  //   setShowMachinesStat(savedVisibility);
  // }, []);

  useEffect(() => {
    setLocalStorage(showMachinesStat);
  }, [showMachinesStat]);

  useEffect(() => {
    setCurrentPage(1);
  }, [machineFilter, machineRank]); 

  useEffect(() => {
      if (showMachinesStat) {
        getAvarageMachinesSales();
      }
      if (!showMachinesStat) {
        setMachineFilter("");
      }
      setCurrentPage(1);
  }, [paymentType, showMachinesStat]);

  useEffect(() => {
    if (showMachinesStat) getMachinesSales30d();
  }, [showMachinesStat]);

  useEffect(() => {
      if (showMachinesStat) {
          getAvarageMachinesSales();
      }
  }, [timeRange]);

  useEffect(() => {
    if (chartRef.current) {
      chartRef.current.update();
    }
    if (chartRef2.current) {
      chartRef2.current.update();
    }
  }, [avarageMachinesSale]);

  const calculateAverageOfAverages = () => {
    if (!avarageMachinesSale || avarageMachinesSale.length === 0) return 0;

    const sum = avarageMachinesSale.reduce(
      (acc, machine) => acc + parseFloat(machine.AverageIncomeValue || 0),
      0
    );
    return sum / avarageMachinesSale.length;
  };
  const calculateAverageOfSum = () => {
    if (!avarageMachinesSale || avarageMachinesSale.length === 0) return 0;

    const sum = avarageMachinesSale.reduce(
      (acc, machine) => acc + parseFloat(machine.SummaryIncomeValue || 0),
      0
    );
    return sum / avarageMachinesSale.length;
  };

  const averageOfAverages = calculateAverageOfAverages();
  const averageOfSum = calculateAverageOfSum();

  const maxAvarageValue = Math.max(
    ...avarageMachinesSale.map(
      ({ AverageIncomeValue }) => parseFloat(AverageIncomeValue) || 0
    )
  );
  const maxSummaryValue = Math.max(
    ...avarageMachinesSale.map(
      ({ SummaryIncomeValue }) => parseFloat(SummaryIncomeValue) || 0
    )
  );
  const summaryChartRatio =
    ((maxAvarageValue || 1) / (averageOfSum || 1)).toFixed(1) || 0;
  const avarageChartRatio =
    ((maxSummaryValue || 1) / (averageOfAverages || 1)).toFixed(1) || 0;

  useEffect(() => {
    if (chartRef.current && chartRef.current.canvas) {
      try {
        const chart = chartRef.current;

        if (chart.data && chart.data.datasets) {
          chart.data.datasets[0].backgroundColor = currentData.map(
            (machine) => {
              const value = parseFloat(machine.AverageIncomeValue);
              return getGradientForBarValue(
                chart,
                value,
                averageOfAverages,
                avarageChartRatio
              );
            }
          );

          chart.update();
        }
      } catch (e) {
        console.error("Failed to apply gradients to first chart:", e);
      }
    }

    if (chartRef2.current && chartRef2.current.canvas) {
      try {
        const chart = chartRef2.current;

        if (chart.data && chart.data.datasets) {
          chart.data.datasets[0].backgroundColor = currentData.map(
            (machine) => {
              const value = parseFloat(machine.SummaryIncomeValue);
              return getGradientForBarValue(
                chart,
                value,
                averageOfSum,
                summaryChartRatio
              );
            }
          );

          chart.update();
        }
      } catch (e) {
        console.error("Failed to apply gradients to second chart:", e);
      }
    }
  }, [currentData, currentPage, averageOfAverages, averageOfSum]);

  const chartData = {
    labels:
      machinesSale30d?.map((machine) => machine.MachineFullName || "") || [],
    datasets: [
      {
        data:
          machinesSale30d?.map((machine) =>
            parseFloat(machine.AverageIncomeValue)
          ) || [],
        borderWidth: 1,
        barThickness: 15,
        borderRadius: {topRight: 5, bottomRight: 5},
        borderSkipped: false,
      },
    ],
  };

  const chartData2 = {
    labels:
      currentData?.map((machine) => machine.MachineFullName || "") || [],
    datasets: [
      {
        data:
          currentData?.map((machine) =>
            parseFloat(machine.SummaryIncomeValue)
          ) || [],
        borderWidth: 1,
        barThickness: 15,
        borderRadius: {topRight: 5, bottomRight: 5},
        borderSkipped: false,
      },
    ],
  };

  return (
    <div>
      <AverageMachineSellFilter
        currentPage={currentPage}
        totalPages={totalPages}
        setCurrentPage={setCurrentPage}
        machineFilter={machineFilter}
        setMachineFilter={setMachineFilter}
        itemsPerPage={itemsPerPage}
        setItemsPerPage={setItemsPerPage}
        filteredData={filteredData}
        totalCount={avarageMachinesSale ? avarageMachinesSale.length : 0}
        paymentType={paymentType}
        setPaymentType={setPaymentType}
        machines={
          avarageMachinesSale.length
            ? avarageMachinesSale.map(({ MachineFullName }) => MachineFullName)
            : []
        }
        isVisible={showMachinesStat}
        setIsVisible={setShowMachinesStat}
        setSortType={setSortType}
        sortType={sortType}
        showAVG={showAVG}
        setShowAVG={setShowAVG}
        getData={getAvarageMachinesSales}
        showMedian={showMedian}
        setShowMedian={setShowMedian}
        machineRank={machineRank}
        setMachineRank={setMachineRank}
            timeRange={timeRange}
    setTimeRange={setTimeRange}
      />
      {filteredData.length === 0 && machineFilter && (
        <div
          className="alert"
          style={{ backgroundColor: "#C5D8FF", fontWeight: "bolder" }}
        >
          Nie znaleziono automatów pasujących do filtra "{machineFilter}"
        </div>
      )}
      {showMachinesStat && (
        <div
          className="container-fluid"
          style={{ maxHeight: "80vh", overflowY: "auto" }}
        >
          <div className="row">
            <div
              style={{
                height: `${Math.max(
                  400,
                  Math.min(currentData.length, filteredData.length) * 30
                )}px`,
              }}
              className="col-lg-6 col-md-11 col-11"
            >
              <Bar
                ref={chartRef}
                data={chartData}
                options={getMachinesSalesAverageChartConfig(
                  showAVG,
                  setShowAVG,
                  currentData,
                  averageOfAverages,
                  itemsPerPage,
                  showMedian,
                  medianOfAverages
                )}
              />
            </div>
            <div
              style={{
                height: `${Math.max(
                  400,
                  Math.min(currentData.length, filteredData.length) * 30
                )}px`,
              }}
              className="col-lg-6 col-md-11 col-11"
            >
              <Bar
                ref={chartRef2}
                data={chartData2}
                options={getMachinesSalesSumChartConfig(
                  showAVG,
                  setShowAVG,
                  currentData,
                  averageOfSum,
                  itemsPerPage,
                  showMedian,
                  medianOfSum
                )}
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}